import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const MasterProtectedRoute = ({ children }) => {
  const { adminUser } = useAuth();
  const location = useLocation();

  // If user is not logged in as admin, redirect to admin login
  if (!adminUser) {
    return <Navigate to="/admin" state={{ from: location }} replace />;
  }

  // If user is logged in but not an Admin (role !== "A"), redirect to dashboard
  if (adminUser.role !== "A") {
    return <Navigate to="/admin/dashboard" state={{ from: location }} replace />;
  }

  return children;
};

export default MasterProtectedRoute;